import { render } from "./SecondComponent.vue?vue&type=template&id=5500bc95&scoped=true"
import script from "./SecondComponent.vue?vue&type=script&lang=js"
export * from "./SecondComponent.vue?vue&type=script&lang=js"

import "./SecondComponent.vue?vue&type=style&index=0&id=5500bc95&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5500bc95"]])

export default __exports__